module.exports = __webpack_public_path__ + "static/img/research.890cf44d.png";